import { PropsWithChildren, useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, LinearProgress, SxProps, Theme } from '@mui/material';
import PaperContainer from 'components/containers/PaperContainer';

type Props = {
	className?: string;
	loading?: boolean;
	paper?: boolean;
	sx?: SxProps<Theme>;
};

function FullLayout({ children, className, loading = false, paper = true, sx }: PropsWithChildren<Props>) {
	const { classes } = useStyles();

	const Component = useMemo(() => (paper ? PaperContainer : Box), [paper]);

	return (
		<Component className={className || classes.root} sx={sx}>
			{loading && <LinearProgress />}
			{children}
		</Component>
	);
}

export default FullLayout;

const useStyles = makeStyles()((theme) => ({
	root: {
		padding: theme.spacing(2),
		// 180px header height
		height: 'calc(100vh - 180px)',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
}));
